import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";

type Field = "geometry" | "textOffset" | "leaderVisible" | "strokeWidth" | "textBoxWidth" | "tag" | "labelGroup" | "archived";
type Version = { measurementId: Id<"takeoffPilotMeasurements">; field: Field; version: number };
type Change = Version & { beforeVersion: number };
type Cursor = Version;

/** Connect local edits only when the server confirms an uninterrupted field revision. */
export class MeasurementHistoryLineage {
  private readonly cursors = new Map<string, Cursor>();

  track(changes: Change[]): Cursor[] {
    return changes.map(({ measurementId, field, beforeVersion }) => {
      const key = `${measurementId}:${field}`;
      let cursor = this.cursors.get(key);
      if (!cursor || cursor.version !== beforeVersion) {
        cursor = { measurementId, field, version: beforeVersion };
        this.cursors.set(key, cursor);
      }
      return cursor;
    });
  }

  expected(cursors: Cursor[]): Version[] {
    return cursors.map(({ measurementId, field, version }) => ({ measurementId, field, version }));
  }

  advance(cursors: Cursor[], changes: Change[]) {
    for (const change of changes) {
      const cursor = cursors.find(item => item.measurementId === change.measurementId && item.field === change.field);
      if (!cursor || cursor.version !== change.beforeVersion) throw new Error("Measurement history revision did not match the completed edit");
      cursor.version = change.version;
    }
  }
}
